import React, { useContext, useRef, useEffect } from "react";
import { MenuContext } from "../../widgets/Menu/context";
import StyledMenuItem, { StyledMenuItemContainer } from "./styles";
import { MenuItemProps } from "./types";
import { useMatchBreakpointsContext } from "../../contexts";
import { DropdownMenuItemType } from "../DropdownMenu/types";


const MenuItem: React.FC<MenuItemProps> = ({
  children,
  href,
  isActive = false,
  variant = "default",
  scrollLayerRef,
  statusColor,
  type,
  ...props
}) => {
  const { isMobile } = useMatchBreakpointsContext();
  const menuItemRef = useRef<HTMLDivElement>(null);
  const { linkComponent } = useContext(MenuContext);
  const itemLinkProps: any = href
    ? {
      as: linkComponent,
      href
    }
    : {
      as: "div",
    };
  useEffect(() => {
    if (!isMobile || !isActive || !menuItemRef.current || !scrollLayerRef?.current) return;
    const scrollLayer = scrollLayerRef.current;
    const menuNode = menuItemRef.current.parentNode as HTMLDivElement;
    if (!menuNode) return;
    if (
      scrollLayer.scrollLeft > menuNode.offsetLeft ||
      scrollLayer.scrollLeft + scrollLayer.offsetWidth < menuNode.offsetLeft + menuNode.offsetWidth
    ) {
      scrollLayer.scrollLeft = menuNode.offsetLeft;
    }
  }, [isActive, isMobile, scrollLayerRef]);
  return (
    <StyledMenuItemContainer $isActive={isActive} $variant={variant} ref={menuItemRef}>
      {type && type === DropdownMenuItemType.EXTERNAL_LINK ? (
        <StyledMenuItem {...itemLinkProps} target="_blank" $isActive={isActive} $variant={variant} $statusColor={statusColor} {...props}>
          {children}
        </StyledMenuItem>
      ) : (
        <StyledMenuItem {...itemLinkProps} $isActive={isActive} $variant={variant} $statusColor={statusColor} {...props}>
          {children}
        </StyledMenuItem>
      )}
    </StyledMenuItemContainer>
  );
};

export default MenuItem;
